"use client";
//#region packages/@mantine/core/src/core/utils/get-default-z-index/get-default-z-index.ts
const elevations = {
	app: 100,
	modal: 200,
	popover: 300,
	overlay: 400,
	max: 9999
};
function getDefaultZIndex(level) {
	return elevations[level];
}
//#endregion
export { getDefaultZIndex };

//# sourceMappingURL=get-default-z-index.mjs.map